import { NewsDTO } from "../domain/models/dto/NewsDTO";
import { INews } from "../domain/models/News";
import { NewsModel } from "../models/NewsModel";
import { FileMapper } from "./FileMapper";
import { NewsTranslationMapper } from "./NewsTranslationMapper";
import { SimpleMapper } from "./SimpleMapper";

export class NewsMapper extends SimpleMapper<INews, NewsDTO> {
    protected toDTOFields: string[] = ["id", "files", "translations"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "availableLangs",
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = NewsModel;
    private fileMapper = new FileMapper();
    private newsTranslationMapper = new NewsTranslationMapper();

    toDTO(model: INews): NewsDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);

        baseDto.translations =
            model.translations?.map((t) =>
                this.newsTranslationMapper.toDTO(t)
            ) ?? [];

        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }

    fromDTO(dto: NewsDTO): INews {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);

        baseModel.translations =
            dto.translations?.map((t) =>
                this.newsTranslationMapper.fromDTO(t)
            ) ?? [];

        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
